import { gettext } from '@eventbrite/i18n';
import { RatingDisplay } from '@eventbrite/trust-signals-lib';
import React from 'react';
import { isDisplayRatingFeatureGateEnabled } from '../../statsig';
import type { Organizer } from '../../types';

export type Props = {
    orgProfileLink: string;
    organizationNameTruncated: string;
    organizerId: Organizer['id'];
    gaCategory: string;
};

export const OrganizerInfo = ({
    orgProfileLink,
    organizationNameTruncated,
    organizerId,
    gaCategory,
}: Props) => {
    const organizerNameMarkup = {
        __html: gettext(
            '<span className="listing-organizer-by">by</span> <a id="organizer-link-org-panel" href="%(orgProfileLink)s" target="_blank" rel="noreferrer" className="listing-organizer-name text-default">%(organizationNameTruncated)s</a>',
            { orgProfileLink, organizationNameTruncated },
        ).toString(),
    };

    return (
        <div className="l-mar-top-3">
            <div className="l-media clrfix listing-organizer-title">
                <div className="l-align-left">
                    <div className="listing-organizer-name-container">
                        <div
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={organizerNameMarkup}
                        />
                    </div>
                    {isDisplayRatingFeatureGateEnabled() && (
                        <RatingDisplay
                            organizerData={{
                                organizerId,
                                organizerName: organizationNameTruncated,
                            }}
                            filterRating
                            addClassToContainer={{
                                className: 'rating-organizer-info__container',
                            }}
                            trackCategory={gaCategory}
                        />
                    )}

                    <span
                        id="listings-root__follow-organizer_hero"
                        className="follow-organizer__mini-container"
                    ></span>
                </div>
            </div>
        </div>
    );
};
